import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const faqData: FAQItem[] = [
  {
    question: '如何选择适合的农业喷水灌溉系统？',
    answer: '选择农业喷水灌溉系统需要综合考虑作物类型、种植面积、地形条件、水源情况和预算等因素。大田作物适合移动式喷灌设备，果园推荐固定式喷灌系统，设施农业则首选滴灌和微喷。建议先进行现场勘测，由专业工程师出具定制化方案。'
  },
  {
    question: '喷水系统安装需要多长时间？',
    answer: '喷水系统的安装周期取决于项目规模和复杂程度。一般家庭花园喷水系统安装需要2-3天，中型农业喷灌项目需要1-2周，大型景观喷泉或工业冷却系统可能需要1-3个月。安装前需完成详细的方案设计和设备采购。'
  },
  {
    question: '喷水系统的日常维护有哪些要点？',
    answer: '喷水系统日常维护包括：定期清洗过滤器和喷头防止堵塞；检查管道接口有无渗漏；监测水泵运行状态；季节性排空管道防冻；保持控制系统正常运行。建议建立维护档案，每月进行一次全面检查。'
  },
  {
    question: '智能喷水系统相比传统系统有哪些优势？',
    answer: '智能喷水系统通过物联网传感器实时监测土壤湿度和气象数据，结合AI算法自动制定最优喷水方案，节水率可达30%以上。同时支持手机远程控制，大幅降低人工管理成本，实现精准灌溉和科学管理。'
  },
  {
    question: '景观喷水装置的设计需要考虑哪些因素？',
    answer: '景观喷水装置设计需考虑场地尺度、周边建筑风格、人流动线、水源水质、安全规范和节能要求。音乐喷泉还需考虑音响灯光系统配合，旱地喷泉需做好地下空间规划。建议选择有丰富项目经验的专业设计团队。'
  },
  {
    question: '工业喷水冷却系统如何实现节能降耗？',
    answer: '工业喷水冷却系统的节能优化可从以下几方面入手：采用变频水泵根据负荷自动调节水量；优化喷水模式减少无效蒸发；回收利用冷却水余热；定期维护保持热交换效率；引入智能控制系统实现精细化管理。综合节能率可达20%-40%。'
  }
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-100" aria-labelledby="faq-title">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <h2 id="faq-title" className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-3">
            常见问题解答
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            关于喷水系统的常见疑问，这里都有答案
          </p>
        </div>

        <div className="space-y-3">
          {faqData.map((item, index) => (
            <div
              key={index}
              className="rounded-lg border border-background-200/70 bg-background-50 overflow-hidden"
            >
              <button
                onClick={() => toggle(index)}
                className="w-full flex items-center justify-between p-5 text-left cursor-pointer whitespace-nowrap"
                aria-expanded={openIndex === index}
              >
                <span className="font-heading text-sm md:text-base font-medium text-foreground-900 pr-4">
                  {item.question}
                </span>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i
                    className={`ri-${openIndex === index ? 'subtract' : 'add'}-line text-lg text-foreground-600 transition-transform duration-200`}
                  ></i>
                </div>
              </button>
              {openIndex === index && (
                <div className="px-5 pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'FAQPage',
              mainEntity: faqData.map((item) => ({
                '@type': 'Question',
                name: item.question,
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: item.answer,
                },
              })),
            }),
          }}
        />
      </div>
    </section>
  );
}